import { useEffect } from 'react'

// TODO: confirm with the AI platform which attribute carries the user token.
const TOKEN_ATTRIBUTE = 'data-token'

const SCRIPT_ATTRIBUTES: Record<string, string> = {
  'data-display-mode': 'modal',
  'data-position-bottom-px': '50',
  'data-position-right-px': '20',
}

interface AiChatBubbleProps {
  scriptUrl: string
  token: string
}

// Injects the platform's embed script, which renders and owns the bubble itself. The token is
// minted per page load: it is single use and the platform rejects one whose `iat` is older than
// its configured max age, so it is never cached or reused across loads.
const AiChatBubble = ({ scriptUrl, token }: AiChatBubbleProps) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = scriptUrl
    script.async = true
    script.setAttribute(TOKEN_ATTRIBUTE, token)
    Object.entries(SCRIPT_ATTRIBUTES).forEach(([name, value]) => script.setAttribute(name, value))

    document.body.appendChild(script)

    return () => {
      script.remove()
    }
  }, [scriptUrl, token])

  return null
}

export default AiChatBubble
